import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import MainLayout from './components/layout/MainLayout';
import Dashboard from './pages/Dashboard';
import PricingPlans from './pages/PricingPlans';
import Pricing from './pages/Pricing';
import ServicePackages from './pages/ServicePackages';
import AIInterviewPage from './pages/AIInterviewPage';
import Advizzu from './pages/Advizzu';
import AdvizzuServices from './pages/AdvizzuServices';
import Marketplace from './pages/Marketplace';
import Projects from './pages/Projects';
import Analytics from './pages/Analytics';
import AdminDashboard from './pages/AdminDashboard';
import AdminPublishing from './pages/AdminPublishing';
import PaymentPage from './pages/PaymentPage';
import ServicesPartners from './pages/ServicesPartners';
import CatalystStart from './pages/CatalystStart';
import CatalystWizard from './pages/CatalystWizard';
import CatalystResults from './pages/CatalystResults';
import CatalystHistory from './pages/CatalystHistory';
import { Toaster } from './components/ui/sonner';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('companeze_token') !== null;
  });

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('companeze_token');
    localStorage.removeItem('companeze_user');
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/interview" element={<AIInterviewPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/payment/success" element={<PaymentPage />} />
          <Route path="/payment/cancel" element={<PaymentPage />} />
          <Route path="/services" element={<AdvizzuServices />} />
          <Route path="/partners" element={<ServicesPartners />} />
          
          {/* Catalyst Routes (Public) */}
          <Route path="/catalyst" element={<CatalystStart />} />
          <Route path="/catalyst/wizard" element={<CatalystWizard />} />
          <Route path="/catalyst/results/:runId" element={<CatalystResults />} />
          <Route path="/catalyst/history" element={<CatalystHistory />} />
          
          {/* Protected Routes with Main Layout */}
          <Route element={isAuthenticated ? <MainLayout onLogout={handleLogout} /> : <Navigate to="/login" />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/pricing-plans" element={<PricingPlans />} />
            <Route path="/advizzu" element={<Advizzu />} />
            <Route path="/advizzu-services" element={<AdvizzuServices />} />
            <Route path="/ai-interview" element={<AIInterviewPage />} />
            <Route path="/service-packages" element={<ServicePackages />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/client-portal" element={<Projects />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/reports" element={<Analytics />} />
            <Route path="/new-business" element={<AIInterviewPage />} />
            <Route path="/business-plans" element={<Projects />} />
            <Route path="/financials" element={<Analytics />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/publishing" element={<AdminPublishing />} />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
